export default function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n  <header class="label-box-editor-button">\n    <h3 class="headline-3">Status</h3>\n    ';
 if ($("body").data("username")) { ;
__p += '\n    <span class="js-Issue-categoryEditor">\n      <button class="nav-button nav-link icon right js-CategoryEditorLauncher js-MilestoneEditorLauncher" aria-label="Edit Statuses">\n        <svg class="nav-text icon nav-icon" viewBox="0 0 30 30" role="presentation" aria-hidden="true">\n            <use xlink:href="#svg-sliders" />\n        </svg>\n      </button>\n    </span>\n    ';
 } ;
__p += '\n  </header>\n   <div class="js-Category-list">\n    <span class="label label-' +
((__t = ( data.milestoneClass )) == null ? '' : __t) +
' js-Milestone">\n      ' +
((__t = ( data.milestone )) == null ? '' : __t) +
'\n    </span>\n  </div>\n\n';
return __p
}